import { Injectable } from '@angular/core';
import { ServiceProvider } from './service.provider';
import { DMSBaseService } from './dms.base.service';

@Injectable({ providedIn: 'root' })
export class LockService extends DMSBaseService {
  constructor(public provider: ServiceProvider) {
    super("/lock", provider);
  }

  checkOutAsset(ids:string[]) {
    return this.save(ids,"")
  }

  checkInAsset(ids:string[]) {
    return this.deleteWithBody(ids,'')
  }

  requestRelease(data) {
    return this.save(data,'/request-release')
  }

}